import { RiskAssessmentData } from "../features/data/patientApiSlice";
import { TFunction } from "i18next";

export const riskAssessmentColors: {
  [classification: string]: string;
} = {
  high: "red",
  medium: "orange",
  further_screening_required: "red",
  tb_vulnerable: "red",
};

export const getRiskScoreClassification = (
  riskAssessment: RiskAssessmentData
): string => {
  return riskAssessment.risk_score_classification || "unknown";
};

export const getRiskScoreClassificationShortName = (
  t: TFunction,
  riskAssessment: RiskAssessmentData
): string => {
  const classification = getRiskScoreClassification(riskAssessment);
  return t([
    `riskScoreClassifications:${riskAssessment.type}:${classification}:shortName`,
    `riskScoreClassifications:common:${classification}:shortName`,
  ]);
};

export const getRiskScoreClassificationLongName = (
  t: TFunction,
  riskAssessment: RiskAssessmentData
): string => {
  const classification = getRiskScoreClassification(riskAssessment);
  return t([
    `riskScoreClassifications:${riskAssessment.type}:${classification}:longName`,
    `riskScoreClassifications:${riskAssessment.type}:${classification}:shortName`,
    `riskScoreClassifications:common:${classification}:longName`,
    `riskScoreClassifications:common:${classification}:shortName`,
  ]);
};
